import { CallActions } from "../interface/callReducerTypes";
import { Types } from "../action/action";
import { createSlice } from "@reduxjs/toolkit";
import { userAgentDetail } from "../models/callModals";

const initialState = {
  userAgent: "",
  isSuccess: false,
  conversationNav: "",
  isDialPadOpen: false,
  isCalling: false,
  isTransfer: false,
  isTrackAgent: false,
  trackAgentDetail: {},
  monitorType: "",
  isTransferSuccess: false,
  isMergeButton: false,
  isTransferButton: false,
  mergedCall: false,
  dialedNumber: "",
  callFlowListData: [],
  transfer_type: "",
  chatFlowListData:[]
};

export const callReducer = (
  state: userAgentDetail = initialState,
  action: CallActions
) => {
  switch (action.type) {
    case Types.DIAL_PAD_OPEN:
      return {
        ...state,
        isDialPadOpen: action.payload.isDialPadOpen,
        isCalling: action.payload.isCalling,
        isTransfer: action.payload.isTransfer,
        isTransferSuccess: action.payload.isTransferSuccess,
        isMergeButton: action.payload.isMergeButton,
        isTransferButton: action.payload.isTransferButton,
      };
    case Types.USER_AGENT_REDUCER:
      return {
        ...state,
        userAgent: action.payload.userAgent,
        isSuccess: action.payload.isSuccess,
      };

    case Types.CONVERSATION_NAV:
      return {
        ...state,
        conversationNav: action.payload.conversationNav,
      };
    case Types.MERGE_DIALPAD:
      return {
        ...state,
        mergedCall: action.payload.mergedCall,
      };
    case Types.TRACK_AGENT:
      return {
        ...state,
        isTrackAgent: action.payload.isTrackAgent,
        trackAgentDetail: action.payload.trackAgentDetail,
      };
    case Types.MONITOR_TYPE:
      return {
        ...state,
        monitorType: action.payload.monitorType,
      };
    case Types.DIALED_NUMBER:
      return {
        ...state,
        dialedNumber: action.payload.dialedNumber,
      };

    case Types.GET_CALLFLOW_LIST:
      return {
        ...state,
        callFlowListData: action.payload.callFlowListData,
      };
    case Types.TRANSFER_TYPE:
      return {
        ...state,
        transfer_type: action.payload.transfer_type,
      };
      case Types.GET_CHATFLOW_LIST:
        return {
          ...state,
          chatFlowListData: action.payload.chatFlowListData,
        };
      
    default:
      return state;
  }
};
